<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        v-model="selected"
        value-key="IdSociedad"
        :id-vista="idVista"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        @datastatechange="dataStateChange"
        @actionclick="openPath">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="primary" :text="labelBtnExcel" icon="excelxls" @click="exportExcel" :loading="isGeneralLoading || loadingExcel" :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('agenda.link_sellers')" icon="link" @click="golinkStatusToUser" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" />
              {{$t('app.unlink_entity')}}
          </base-button-item-list>
        </template>
      </base-table-select-actions-expand>
      <user-link-provider-dialog :dialogOpen="linkStatusToUserDialog" :userId="$route.params.id" @toggleDialog="toggleDialogs" @applyDialog="applyLinkHandler" />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" :vuexnamespace="'companyprovideruser'" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { bus } from '@/main'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/UserProviderFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import UserLinkProviderDialog from '@/components/UserLinkProviderDialog.vue'

import { getUser } from '@/services/configurations/getUser'
import { getSociedadesPag } from '@/services/configurations/getSociedadesPag'
import { getSociedadesExcel } from '@/services/configurations/getSociedadesExcel'
import { linkProveedoresUsuarios } from '@/services/configurations/linkProveedoresUsuarios'
import { unlinkProveedoresUsuarios } from '@/services/configurations/unlinkProveedoresUsuarios'


export default {
  name: 'company-provider-by-user',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    UserLinkProviderDialog,
  },
  data: function () {
    return {
      idVista: 80,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkStatusToUserDialog: false,
      spanish: true,
      header: {
        title: i18n.t('agenda.seller_link'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/users/details'
      },
      vuexnamespace: 'companyprovideruser',
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    }
  },
  created: function () {
  },
  mounted: async function () {
    const userId = this.$route.params.id

    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/users', name: i18n.t('users.header') })

    const user = await this.downloadData(userId)
    breadcrumbs.push({ path: '', name: user.Usuario })
    this.$store.commit('app/setheaderBreadCrumb', user.Usuario)
    this.disableRoutes(user)
    
    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {
    disableRoutes: function (user) {
      const isDisabledByRol = (user.idRol === 7 || user.idRol === 8 || user.idRol === 3)
      const isDisabledByProvider = user.idRol === 9
      const objDisableRoutes = {
        disableGroups: isDisabledByRol || isDisabledByProvider,
        disableStatuses: user.VerTodoEstados || isDisabledByRol || isDisabledByProvider,
        disableCompanies: user.VerTodoEmpresas || isDisabledByRol || isDisabledByProvider,
        disableProviderCompanies: !isDisabledByProvider
      }
      bus.$emit('disableOptionsUser', objDisableRoutes)
    },
    openPath: function (event) {
      this.$router.push({ name: 'masters/society/details', params: { id: event.dataItem.IdSociedad, selfInvoice: event.dataItem.IsSeflInvoiceSociety } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkStatusToUserDialog = !this.linkStatusToUserDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idUsuario: this.$route.params.id,
        NameCorporateName: data.NameCorporateName ? data.NameCorporateName.value : null,
        TIN: data.TIN ? data.TIN.value : null,
        FirstSurname: data.FirstSurname ? data.FirstSurname.value : null,
        SecondSurname: data.SecondSurname ? data.SecondSurname.value : null,
        ResidenceType: data.ResidenceType ? data.ResidenceType.value : null,
        PersonType: data.PersonType ? data.PersonType.value : null,
        Locations: data.Locations ? data.Locations.value : null,
        LinkedCompanies: data.LinkedCompanies ? data.LinkedCompanies.value : null,
        RegisterOfCompaniesLocation: data.RegisterOfCompaniesLocation ? data.RegistrationData.RegisterOfCompaniesLocation.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        payload.listaIDs = this.selected
      }
      try {
        const response = await getSociedadesExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = `${(i18n.t('users.header')+'-'+i18n.t('agenda.sellers')).toLowerCase()}.xlsx`
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idUsuario: this.$route.params.id,
        NameCorporateName: data.NameCorporateName ? data.NameCorporateName.value : null,
        TIN: data.TIN ? data.TIN.value : null,
        FirstSurname: data.FirstSurname ? data.FirstSurname.value : null,
        SecondSurname: data.SecondSurname ? data.SecondSurname.value : null,
        ResidenceType: data.ResidenceType ? data.ResidenceType.value : null,
        PersonType: data.PersonType ? data.PersonType.value : null,
        Locations: data.Locations ? data.Locations.value : null,
        LinkedCompanies: data.LinkedCompanies ? data.LinkedCompanies.value : null,
        RegisterOfCompaniesLocation: data.RegisterOfCompaniesLocation ? data.RegistrationData.RegisterOfCompaniesLocation.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(`${i18n.t('feedback.error.general')} ${error}`)
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getSociedadesPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function (id) {
      let user = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          idUsuario: id
        }
        user = await getUser(params)
        if (user.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', user))
        } else {
          user = user.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return user
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (idSociedades) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = parseInt(this.$route.params.id)
        const payload = { idsSociedad: idSociedades, idUsuariosProveedor: idUsuario }
        const response = await unlinkProveedoresUsuarios(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.unselect()
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkStatusToUser: function () {
      this.linkStatusToUserDialog = !this.linkStatusToUserDialog
    },
    applyLinkHandler: async function (estados) {
      await this.linkHandler(estados)
      this.applyFilters()
    },
    linkHandler: async function (idSociedades) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = parseInt(this.$route.params.id)
        const payload = { idsSociedad: idSociedades, idUsuariosProveedor: idUsuario }
        const response = await linkProveedoresUsuarios(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          this.toggleDialogs()
        }
      } catch (error) {     
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
